module.exports = __webpack_public_path__ + "static/media/login-landscape-header.5fce35b8.svg";